// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_product_group_code: yup.string().label("Group code").required(),
  mr_product_group_name: yup.string().label("Group name").required()
})